export let FileAwarenessMonitorErrorsList = /*#__PURE__*/function (FileAwarenessMonitorErrorsList) {
  FileAwarenessMonitorErrorsList["FailedToAppendParameter"] = "failed-to-append-parameter";
  return FileAwarenessMonitorErrorsList;
}({});
export const FileAwarenessMonitorErrorTypeTag = 'fileAwareness.sentryErrorType';
//# sourceMappingURL=sentryConstants.js.map